// extracted by mini-css-extract-plugin
export default {"homeWrapper":"styles_homeWrapper__PP0KK","container":"styles_container__jTdzI","bottomContent":"styles_bottomContent__N73zR","wrapper":"styles_wrapper__snRZ6"};